<template>
    <form-row title="Fees Paid">
        <input-radio-boolean
            name="fees_paid_gross"
            true="Gross"
            false="Net"
            v-model="fees_paid_gross"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        read_only: { default: false },
    },

    computed: {
        fees_paid_gross: {
            get() {
                return store.state.fees_paid_gross || 0;
            },
            set(val) {
                store.state.fees_paid_gross = (val ? 1 : 0);
            },
        },
    },
}
</script>
